import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: #707070;
`

const Play = ({ title = 'Play', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 24 24" title={title} {...rest}>
    <g transform="translate(-21 -29)" fill="none" fillRule="evenodd">
      <path
        d="M33 29c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm-3 17V36l8 5-8 5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </StyledIcon>
)

Play.displayName = 'Play'
Play.needsWork = true
export default Play
